import PropTypes from 'prop-types';

export const AppPermissionsPropTypes = {
  authorized: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  children: PropTypes.any,
};
